import Layout from '@/components/layout/Layout.vue'
import PullForm from '@/views/sys/ks-series-authorization/pull/Pull.vue'
import { getKsSeriesAuthorizations, pullKsSeriesAuthorization } from '@/api/ks-series-authorization'

export default {
    name: 'ks_series_authorizations',
    components: {
        Layout,
        PullForm
    },
    data() {
        return {
            data: [],
            columns: [
                { minWidth: 70, title: 'ID', fixed: 'left', field: 'id' },
                {
                    minWidth: 170,
                    title: '媒体账号',
                    field: 'account_name',
                    formatter: ({ cellValue, row }) => cellValue || row.account_id
                },
                { minWidth: 130, title: '应用app_id', field: 'app_id', formatter: 'empty' },
                { minWidth: 140, title: '快手号id', field: 'out_id', formatter: 'empty' },
                { minWidth: 160, title: '快手号昵称', field: 'user_name', formatter: 'empty' },
                { minWidth: 220, title: '授权scope', field: 'scope', formatter: 'empty' },
                { minWidth: 170, title: '令牌有效期', field: 'access_token_invalid_at', formatter: 'empty' },
                { minWidth: 170, title: '刷新令牌有效期', field: 'refresh_token_invalid_at', formatter: 'empty' },
                {
                    minWidth: 90,
                    title: '状态',
                    field: 'status',
                    formatter: ({ cellValue }) => (Number(cellValue) === 1 ? '正常' : '失效')
                },
                { minWidth: 170, title: '授权时间', field: 'updated_at', formatter: 'empty' },
                { minWidth: 110, title: '操作', field: 'action', slots: { default: 'action' } }
            ],
            queryParam: {
                out_id: null,
                user_name: null,
                status: null
            },
            showPullForm: false,
            tableGrid: this.getTableGrid()
        }
    },
    mounted() {
        this.tableGrid.columns = this.columns
        this.getData()
    },
    methods: {
        getTableGrid() {
            const grid = this.$helper.tableGrid('ks_series_authorizations')
            grid.size = 'medium'
            grid.border = 'inner'
            return grid
        },
        getData() {
            this.tableGrid.loading = true
            const json = Object.assign({}, this.queryParam, {
                page: this.tableGrid.pagerConfig.currentPage,
                page_size: this.tableGrid.pagerConfig.pageSize
            })
            getKsSeriesAuthorizations(json).then(res => {
                this.tableGrid.pagerConfig.total = res.data.total
                this.tableGrid.loading = false
                this.tableGrid.data = res.data.list
                this.data = res.data.list || []
            }).catch(() => {
                this.tableGrid.loading = false
            })
        },
        search() {
            this.tableGrid.pagerConfig.currentPage = 1
            this.getData()
        },
        resetSearch() {
            this.queryParam = {
                out_id: null,
                user_name: null,
                status: null
            }
            this.getData()
        },
        refresh() {
            this.getData()
        },
        handlePageChange(pager) {
            this.tableGrid.pagerConfig.currentPage = pager.currentPage
            this.tableGrid.pagerConfig.pageSize = pager.pageSize
            this.getData()
        },
        accessTo(route) {
            return this.$helper.accessTo('KsSeriesAuthorizationController', route)
        },
        showPull() {
            this.showPullForm = true
        },
        /**
         * 令牌过期等场景下，按行内媒体账号直接重新授权
         */
        rePull(record) {
            if (!record.account_id) {
                this.$message.error('该记录缺少媒体账号，无法重新授权')
                return
            }
            window.open(pullKsSeriesAuthorization(record.account_id))
        }
    }
}
